/**
 * Created by Alex on 2018/1/10.
 */
const API = `/api/v1`
const URL = `/v1/web`
// 登录地址
export const CHECK_LOGIN_API = `${API}/auth/checkStatus?username={username}`
export const LOGIN_API = `${API}/auth/authentication/form`
export const USER_INFO_API = `${API}/auth/me`
// 保存开发者信息
export const DEV_SAVE_API = `${API}/auth/api/manage/developer`
// 开通服务
export const DEV_OPEN_API = `${API}/auth/api/manage/resource_permission/open`
// 续费服务
export const DEV_RENEW_API = `${API}/auth/api/manage/resource_permission/renew`

// 用户申请联系我们
export const CONTACT_US_API = `${API}/auth/api/apply`

// 启用禁用
export const DEV_OPEN_ENABLE_API = `${API}/auth/api/manage/resource_permission/{id}/enable`
export const DEV_OPEN_DISABLE_API = `${API}/auth/api/manage/resource_permission/{id}/disable`
export const DEV_MODIFY_INFO_API = `${API}/auth/api/manage/developer/{id}`
export const DEV_MODIFY_API = `${API}/auth/api/manage/resource_permission/{id}/invoke`
export const DEV_APPLY_API = `${API}/auth/api/apply?status={status}&companyName={companyName}&pageNumber={pageNumber}&pageSize={pageSize}`
export const DEV_UPDATE_REMARK_API = `${API}/auth/api/apply/{id}/remark?remark={remark}`
export const DEV_RESOURCE_API = `${API}/auth/api/manage/developer/{id}/resource`
export const DEV_RESOURCE_HISTORY_API = `${API}/auth/api/manage/history?pageNumber={pageNumber}&pageSize={pageSize}&userId={userId}&isClient={isClient}`

// 获取开发者列表
export const DEV_LIST_API = `${API}/auth/api/manage/page-developers?status={status}&companyName={companyName}&pageNumber={pageNumber}&pageSize={pageSize}`
// 学段
export const STAGES_API = `${API}/basic/manager/stages`
export const STAGE_SAVE_API = `${API}/basic/manager/stage` // 新增/修改
export const STAGE_ENABLE_API = `${API}/basic/manager/stage/{id}/update/status/{use}` // 启用或者禁用
// 科目
export const SUBJECT_API = `${API}/basic/manager/stage/{id}/subjects`
export const SUBJECT_SAVE_API = `${API}/basic/manager/subject` // 新增/修改
export const SUBJECT_ENABLE_API = `${API}/basic/manager/subject/{id}/update/status/{use}`// 启用或者禁用
// 版本
export const VERSION_API = `${API}/basic/manager/{id}/versions/{basicDocumentStatus}/basicDocumentStatus?specifyModuleId={specifyModuleId}`
export const VERSION_SAVE_API = `${API}/basic/manager/version`// 新增/修改
export const VERSION_ENABLE_API = `${API}/basic/manager/version/{id}/update/status/{use}`
// 册别
export const VOLUME_API = `${API}/basic/manager/version/{id}/textbooks?specifyModuleId={specifyModuleId}`
export const VOLUME_SAVE_API = `${API}/basic/manager/textbook` // 新增/修改
export const VOLUME_ENABLE_API = `${API}/basic/manager/textbook/{id}/update/status/{use}`
// 试题类型
export const EXAMTYPE_API = `${API}/basic/manager/subject/{id}/question/types`
export const EXAMTYPE_SAVE_API = `${API}/basic/manager/question/type`
export const EXAMTYPE_ENABLE_API = `${API}/basic/manager/question/type/{id}/update/status/{use}`

// 章节
export const BOOKNODE_API = `${API}/basic/manager/textbook/{id}/book/node/tree`
export const BOOKNODE_SAVE_API = `${API}/basic/manager/book/node`
export const BOOKNODE_REMOVE_API = `${API}/basic/manager/book/node/{id}`
// 中考高考
export const BOOKNODE_ZGK_API = `${API}/basic/manager/exam/book/node?subjectId={subjectId}&columnId={columnId}`
export const BOOKNODE_ZGK_SAVE_API = `${API}/basic/manager/exam/book/node`
export const BOOKNODE_ZGK_REMOVE_API = `${API}/basic/manager/book/node/{id}`
// 试卷
export const BOOKNODE_SJ_API = `${API}/basic/manager/re/exam/book/node?subjectId={subjectId}`
export const BOOKNODE_SJ_SAVE_API = `${API}/basic/manager/re/exam/book/node`
export const BOOKNODE_SJ_REMOVE_API = `${API}/basic/manager/re/book/node/{id}`
// 知识点
export const KNOWLEDGE_API = `${API}/basic/manager/subject/{id}/knowledge/point/tree`
export const KNOWLEDGE_SAVE_API = `${API}/basic/manager/knowledge/point`
export const KNOWLEDGE_REMOVE_API = `${API}/basic/manager/knowledge/point/{id}`

// 公共服务
export const COMMON_STAGE_API = `${API}/basic/manager/common/stages`
export const COMMON_GRADE_API = `${API}/basic/manager/grade/stage/{stage}`
export const COMMON_SUBJECT_API = `${API}/basic/manager/common/stage/{id}/subjects`
export const COMMON_VERSION_API = `${API}/basic/manager/common/subject/{id}/versions?isAllData={isAllData}&specifyModuleId={specifyModuleId}`
export const COMMON_TEXTBOOK_API = `${API}/basic/manager/common/version/{id}/textbooks?isAllData={isAllData}&specifyModuleId={specifyModuleId}`
export const COMMON_COLUMN_API = `${API}/basic/manager/stages/{stageId}/type/0/columns`
export const COMMON_EXAMHARD_API = `${API}/basic/manager/common/question/difficult`
export const COMMON_EXAMTYPE_API = `${API}/basic/manager/document-paper-types?gradeId={gradeId}&stageId={stageId}`

// 用户管理
export const USER_LIST_API = `${API}/auth/api/manage/users?account={account}&pageNumber={pageNumber}&pageSize={pageSize}`
export const USER_SAVE_API = `${API}/auth/api/manage/user`
export const USER_UPDATE_API = `${API}/auth/api/manage/user/{id}`
export const USER_ENABLE_API = `${API}/auth/api/manage/user/{id}/enable`
export const USER_DISABLE_API = `${API}/auth/api/manage/user/{id}/disable`
export const USER_RESET_API = `${API}/auth/api/manage/user/{id}/password/reset`
export const USER_ROLE_LIST_API = `${API}/auth/api/manage/roles`

// 全趋势统计
export const STATISTICS_INVOKE_ALL_API = `${API}/invoke/manage/statistics/all/invoke?fromDate={fromDate}&toDate={toDate}`
export const STATISTICS_INVOKE_COMMON_API = `${API}/invoke/manage/statistics/common/invoke?fromDate={fromDate}&toDate={toDate}`
export const STATISTICS_INVOKE_QUESTION_API = `${API}/invoke/manage/statistics/question/invoke?fromDate={fromDate}&toDate={toDate}&resourceType={resourceType}`
export const STATISTICS_INVOKE_QUESTION_V4_API = `${API}/invoke/manage/statistics/question/v4/invoke?fromDate={fromDate}&toDate={toDate}`
export const STATISTICS_INVOKE_DOCUMENT_API = `${API}/invoke/manage/statistics/document/invoke?fromDate={fromDate}&toDate={toDate}&resourceType={resourceType}`
export const STATISTICS_INVOKE_DETAIL_API = `${API}/invoke/manage/statistics/question/detail/invoke?fromDate={fromDate}&toDate={toDate}&resourceType={resourceType}`
export const STATISTICS_INVOKE_QUESTION_V4_DETAIL_API = `${API}/invoke/manage/statistics/question/v4/detail/invoke?fromDate={fromDate}&toDate={toDate}`
export const STATISTICS_INVOKE_DISTINCT_API = `${API}/invoke/manage/statistics/question/detail/distinct/invoke?fromDate={fromDate}&toDate={toDate}&resourceType={resourceType}`
export const STATISTICS_INVOKE_QUESTION_V4_DISTINCT_API = `${API}/invoke/manage/statistics/question/v4/detail/distinct/invoke?fromDate={fromDate}&toDate={toDate}`
export const STATISTICS_INVOKE_DOWNLOAD_API = `${API}/invoke/manage/statistics/document/download/invoke?fromDate={fromDate}&toDate={toDate}&resourceType={resourceType}`
export const STATISTICS_INVOKE_DOWNLOAD_DISTINCT_API = `${API}/invoke/manage/statistics/document/download/distinct/invoke?fromDate={fromDate}&toDate={toDate}&resourceType={resourceType}`
// 名校文档下载去重下载接口调用
export const STATISTICS_INVOKE_ELITESCHOOL_DOWNLOAD_DISTINCT_API = `${API}/invoke/manage/statistics/eliteSchool/document/download/distinct/invoke?fromDate={fromDate}&toDate={toDate}`
// 名校文档下载接口调用统计
export const STATISTICS_INVOKE_ELITESCHOOL_DOWNLOAD_API = `${API}/invoke/manage/statistics/eliteSchool/document/download/invoke?fromDate={fromDate}&toDate={toDate}`
// 名校文档接口统计
export const STATISTICS_INVOKE_ELITESCHOOL_API = `${API}/invoke/manage/statistics/eliteSchool/document/invoke?fromDate={fromDate}&toDate={toDate}`

// 试卷文档下载去重下载接口调用
export const STATISTICS_INVOKE_SHIJUAN_DOWNLOAD_DISTINCT_API = `${API}/invoke/manage/statistics/paper/download/distinct/invoke?fromDate={fromDate}&toDate={toDate}`
// 试卷文档下载接口调用统计
export const STATISTICS_INVOKE_SHIJUAN_DOWNLOAD_API = `${API}/invoke/manage/statistics/paper/download/invoke?fromDate={fromDate}&toDate={toDate}`
// 试卷文档接口统计
export const STATISTICS_INVOKE_SHIJUAN_API = `${API}/invoke/manage/statistics/paper/invoke?fromDate={fromDate}&toDate={toDate}`
// 专辑文档下载去重下载接口调用
export const STATISTICS_INVOKE_ALBUM_DOWNLOAD_DISTINCT_API = `${API}/invoke/manage/statistics/album/download/distinct/invoke?fromDate={fromDate}&toDate={toDate}`
// 专辑文档下载接口调用统计
export const STATISTICS_INVOKE_ALBUM_DOWNLOAD_API = `${API}/invoke/manage/statistics/album/download/invoke?fromDate={fromDate}&toDate={toDate}`
// 专辑文档接口统计
export const STATISTICS_INVOKE_ALBUM_API = `${API}/invoke/manage/statistics/album/invoke?fromDate={fromDate}&toDate={toDate}`

// 获取微课所有接口调用统计
export const STATISTICS_INVOKE_MICROCLASS_API = `${API}/invoke/manage/statistics/video/invoke?fromDate={fromDate}&toDate={toDate}`
// 获取微课接口下载调用统计
export const STATISTICS_INVOKE_MICROCLASS_DOWNLOAD_API = `${API}/invoke/manage/statistics/video/download/invoke?fromDate={fromDate}&toDate={toDate}`
// 微课下载去重调用统计
export const STATISTICS_INVOKE_MICROCLASS_DOWNLOAD_DISTINCT_API = `${API}/invoke/manage/statistics/video/download/distinct/invoke?fromDate={fromDate}&toDate={toDate}`

// 按接口统计
export const INTERFACE_STATISTICS_API = `${API}/invoke/manage/interfaces`
export const INTERFACE_STATISTICS_DETAIL_API = `${API}/invoke/manage/statistics/interface/{id}/invoke?fromDate={fromDate}&toDate={toDate}`
// // 按接口统计
export const DEVELOPER_STATISTICS_DETAIL_API = `${API}/invoke/manage/statistics/developer/{id}/invoke-statistics?fromDate={fromDate}&toDate={toDate}`
// 上传文件
export const COMMON_UPLOAD_API = `${API}/oss/business-license`
// 验证码
export const COMMON_AUTH_CODE_API = `${API}/auth/code/image`

// 修改密码
export const UPDATE_PWD_API = `${API}/auth/api/manage/signed/password/change`
// 修改密码
export const SEND_CODE_API = `${API}/auth/code/sms?mobile={mobile}&imageCode={imageCode}`
// 开发者注册
export const DEV_REDISTER_API = `${API}/auth/api/developer`
// 获取用户详情=
export const COMMON_DETAIL_API = `${API}/auth/api/developer/logined`

export const COMMON_CLIENT_API = `${API}/auth/api/developer/client/reset`

export const COMMON_STATISTICS_API = `${API}/invoke/statistics?searchDate={searchDate}`

export const PASSWORD_RESET_API = `${API}/auth/api/developer/password-reset`
// 获取文档试卷数量
export const GET_TOTAL_PAPER_API = `${API}/invoke/zykf/exam/numbers`
// 获取文档资源数量
export const GET_TOTAL_DOC_API = `${API}/invoke/zykf/document/numbers`
// 获取题库资源数量
export const GET_TOTAL_QUESTION_API = `${API}/invoke/zykf/question/numbers`
// 获取开发者接口管理列表
export const GET_DEVELOP_STATISTICS = `${API}/auth/api/manage/developer/{developerId}/developerConfigs`
// （用户或过期用户）批量开通资源
export const DEVELOP_BATCH_OPEN = `${API}/auth/api/manage/resource_permission/batch_open`
// 获取单个的资源调用权限
export const GET_RESOURCE_PERMISSION = `${API}/auth/api/manage/resource_permission/{permissionId}`
// 试用用户一键延期7天
export const GET_DELAY = `${API}/auth/api/manage/resource_permission/developer/{developerId}/delay`
// 获取开发者状态
export const GET_DEV_STATUS = `${API}/auth/api/developer/{developerId}/status`
// 开发者审核通过
export const SET_DEV_STATUS_PASS = `${API}/auth/api/manage/developerProcess?userId={userId}`
// 开发者审核拒绝
export const SET_DEV_STATUS_REJECT = `${API}/auth/api/manage/developerRefuse?userId={userId}`
// 获取用户组合开通
export const GET_DEV_ZUHE_OPEN_USER = `${API}/auth/api/manage/getRestrictMerging?userId={userId}`
// 获取组合开通
export const GET_DEV_ZUHE_OPEN = `${API}/invoke/getRestrictMerging?userId={userId}`
// 设置组合开通
export const SET_DEV_ZUHE_OPEN = `${API}/invoke/addRestrictMerging`
// 删除组合开通
export const DEL_DEV_ZUHE_OPEN = `${API}/invoke/deleteRestrictMerging?userId={userId}`



// WEBPACK FOOTER //
// ./src/resource/index.js